var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateDuplicateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6934 5.25H7.58789C6.29671 5.25 5.25 6.29671 5.25 7.58789V16.6934C5.25 17.9845 6.29671 19.0312 7.58789 19.0312H16.6934C17.9845 19.0312 19.0312 17.9845 19.0312 16.6934V7.58789C19.0312 6.29671 17.9845 5.25 16.6934 5.25Z",
    stroke: "#E66100",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7295 5.25L15.75 4.26562C15.7483 3.65699 15.5057 3.07377 15.0753 2.6434C14.645 2.21303 14.0618 1.97048 13.4531 1.96875H4.59375C3.89819 1.97081 3.2317 2.24803 2.73987 2.73987C2.24803 3.2317 1.97081 3.89819 1.96875 4.59375V13.4531C1.97048 14.0618 2.21303 14.645 2.6434 15.0753C3.07377 15.5057 3.65699 15.7483 4.26562 15.75H5.25M12.1406 8.85938V15.4219M15.4219 12.1406H8.85938",
    stroke: "#E66100",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDuplicateIcon);
export default __webpack_public_path__ + "static/media/CreateDuplicateIcon.029eb0a8cad4fb59c6b2bdae5bb0aadf.svg";
export { ForwardRef as ReactComponent };